import { Tag as AntTag } from 'antd';

import styled from 'styled-components';

export const Tag = styled(AntTag)``;
